<script setup>
import DynamicField from './DynamicField.vue';

function resolveChildField(key, value) {
  if (value === null || value === undefined) {
   return { key, type: 'text', label: key }
  }

  if (Array.isArray(value)) {
    return {
      key,
      type: 'multiselect',
      label: key,
      items: value
    }
  }
  if (typeof value == 'true' || typeof value == 'false' ) {
    return { key, type: 'boolean', label: key }
  }

  if (typeof value === 'string') {
    return { key, type: 'text', label: key }
  }

  if (typeof value === 'object') {
    return { key, type: 'object', label: key }
  }

  return { key, type: 'text', label: key }
}

const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  field: Object,
  path: {
    type: Array,
    default: () => []
  }
})

</script>

<template>
<v-card variant="plain" class="pa-4">
  <v-card-title>{{ field.label }}</v-card-title>

  <v-row>
      <template v-for="(value, key) in modelValue" :key="key">
        <template v-if="key !== '__typename'">
          <v-col cols="12" md="6">
        <DynamicField
          :field="resolveChildField(key, value)"
          :model-value="value"
          :path="[...path, key]"
        />
      </v-col>
        </template>
      

      </template>
    
  </v-row>
</v-card>
</template>

 <!-- <DynamicField
          :field="resolveChildField(key, value)"
          :model-value="value"
          @update:modelValue="val => updateChild(key, val)"
        /> -->